import React from 'react';
import { Button, Col, Form, Row, Modal } from "react-bootstrap";
import { HelpOutline } from '@material-ui/icons';
import NumericInput from 'react-numeric-input';
import strategy from 'joi-validation-strategy';
import Joi from 'joi';
import validation from 'react-validation-mixin';
import PropTypes from 'prop-types';
import InfoSharpIcon from '@material-ui/icons/InfoSharp';
import Tooltip from '@material-ui/core/Tooltip';
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { ContentState, convertToRaw, EditorState } from "draft-js";
import $ from "jquery";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";


class ProductInfo extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            product_name: props.getSubscriptionData().product_name,
            product_description: props.getSubscriptionData().product_description,
            formerrors: undefined,
            statement_descriptor: props.getSubscriptionData().statement_descriptor,
            totalTransactions: props.getSubscriptionData().transactionCounter,
            totalText: props.getSubscriptionData().textSentCounter,
            totalTemplate: props.getSubscriptionData().templateCounter,
            totalDocument: props.getSubscriptionData().uploadDocumentSize,
            totalEmail: props.getSubscriptionData().emailSentCounter,
            deletePrompt: false,
            uploadedFileName: props.getSubscriptionData().uploadedFileName,
            textEditorVal: EditorState.createEmpty(),
        };

        this.validatorTypes = function () {
            var base = Joi.object().keys({
                "product_name": Joi.string().required(),
                "product_description": Joi.string().required(),
                "totalTransactions": Joi.number().min(1).required(),
            })
            return base;
        };

        this.getValidatorData = this.getValidatorData.bind(this);
        this.renderHelpText = this.renderHelpText.bind(this);
        this.isValidated = this.isValidated.bind(this);

    }
    componentWillMount() {

        var textEditorVal = EditorState.createEmpty();
        let contentBlock = htmlToDraft(this.props.getSubscriptionData().product_description);
        if (contentBlock) {
            const contentState = ContentState.createFromBlockArray(
                contentBlock.contentBlocks
            );
            textEditorVal = EditorState.createWithContent(contentState);
        }
        this.setState({
            textEditorVal: textEditorVal,
        });


    }
    getValidatorData() {
        return {
            "product_name": this.state.product_name,
            "product_description": this.state.product_description,
            "totalTransactions": this.state.totalTransactions,
        }
    }

	/**
	 * @desc get error message based on field
	 * @param {*} field 
	 * @param {*} errsList 
	 */
    getErrorMsg(field, errsList) {

        var err = '';

        if (field === "product_name" || field === "product_description" || field === "totalTransactions") {
            if (errsList[field] !== undefined && errsList[field] !== null && errsList[field] !== "") {

                if (field === "product_name") {
                    err = 'Please enter Product Name';
                }
                if (field === "product_description") {
                    err = 'Please enter Product description';
                }
                if (field === "totalTransactions") {
                    err = 'Please enter total transactions';
                }
            }

        }
        return err;
    }

	/**
	 * @desc check form is valid or not
	 */
    isValidated() {
        return new Promise((resolve, reject) => {
            this.props.validate((error) => {
                if (error) {
                    this.setState({ formerrors: error })
                    // form contains errors
                    reject();
                    return false;
                }
                resolve();
                return true;
            });
        });
    }

    renderHelpText(message, id) {
        return (<div className="val-err-tooltip" key={id}><span>{message}</span></div>);
    }

	/**
	 * @desc on change event of field
	 * @param {*} event 
	 */
    onChange(event) {
        this.setState({ [event.target.name]: event.target.value });
        this.props.updateSubscriptionData(event.target.name, event.target.value);
    }
    getFormErrs() {
        return this.state.formerrors;
    }
  
    /**
    * @desc open delete promt
    */
    deletePrompt() {
        this.setState({
            deletePrompt: !this.state.deletePrompt,
        })
    }
    render() {

        return (
            <div className="admin-steps admin-content-area">
                <div className="container-custom">
                    <Form className="form-sm form-admin">
                        <Row>
                            <Col md={6}>
                                <h3 className="title-small font-600 mt-2 mb-3 pt-3">Product Information</h3>
                                <Row>
                                    <Col xs={12}>
                                        <Form.Group controlId="">
                                            <Form.Label>Name<span className="text-danger">*</span></Form.Label>
                                            <Form.Control type="text" name="product_name"
                                                value={this.state.product_name}
                                                className="field_ucfirst"
                                                onChange={this.onChange.bind(this)}
                                                onBlur={this.props.handleValidation('product_name')}
                                            />
                                            <Form.Text className="text-danger">
                                                {this.renderHelpText(this.getErrorMsg('product_name', this.props.errors))}
                                            </Form.Text>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12} sm={12}>
                                        <Row>
                                            <Col xs={12}>
                                                <Form.Group controlId="">
                                                    <Form.Label>Statement descriptor &nbsp;
                                                        <Tooltip title="Adding a statement descriptor will override your account descriptor.If you add a statement descriptor,
                                                                                choose something your customers will recognize on a bank statement.">
                                                            <InfoSharpIcon style={{ fontSize: 18 }} />
                                                        </Tooltip>
                                                        </Form.Label>
                                                        <Form.Control type="text" name="statement_descriptor"
                                                                defaultValue={this.state.statement_descriptor}
                                                                className="field_ucfirst"
                                                                onChange={this.onChange.bind(this)}
                                                                maxLength={22}
                                                            />
                                                </Form.Group>
                                                <Form.Text className="text-danger">
                                                </Form.Text>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12}>
                                        <Form.Group controlId="">
                                            <Form.Label>Description<span className="text-danger">*</span></Form.Label>
                                            <Editor
                                                wrapperClassName="demo-wrapper wysi-editor"
                                                editorClassName="demo-editor"
                                                maxLength={250}
                                                toolbar={{
                                                    options: ['inline', 'list', 'link', 'blockType'],
                                                    inline: { inDropdown: false, options: ['bold', 'italic'] },
                                                    list: { inDropdown: true, options: ['unordered', 'ordered'] },
                                                    link: { inDropdown: false, options: ['link'] },
                                                    blockType: { inDropdown: false, options: ['Blockquote'] },
                                                }}
                                                name="product_description"
                                                editorState={this.state.textEditorVal}
                                                onEditorStateChange={e => {
                                                    var editData = draftToHtml(convertToRaw(e.getCurrentContent()));
                                                    var tempDom = $('<output>').append($.parseHTML(editData));
                                                    let finalval = tempDom.html();
                                                    this.props.updateSubscriptionData("product_description",finalval);
                                                    this.setState({
                                                        textEditorVal: e,
                                                        product_description: finalval
                                                    });
                                                }}
                                                hashtag={{}}
                                            />
                                            <Form.Text className="text-danger">
                                                {this.renderHelpText(this.getErrorMsg('product_description', this.props.errors))}
                                            </Form.Text>
                                        </Form.Group>
                                    </Col>
                                </Row>
                              </Col>
                            <Col md={6}>
                                <h3 className="title-small font-600 mt-2 mb-3 pt-3">Limit</h3>
                                <Row>
                                    <Col xs={12}>
                                        <Form.Group controlId="">
                                            <Form.Label >Total Transactions<span className="text-danger">*</span></Form.Label>

                                            <NumericInput
                                                name="totalTransactions"
                                                placeholder="Enter Value"
                                                inputMode="numeric"
                                                strict
                                                style={false}
                                                value={this.state.totalTransactions}
                                                className='form-control text-right emd-input'
                                                onChange={(e) => {
                                                    this.setState({ totalTransactions: e })
                                                    this.props.updateSubscriptionData('transactionCounter', e);
                                                }}
                                            />
                                            <Form.Text className="text-danger">
                                                {this.renderHelpText(this.getErrorMsg('totalTransactions', this.props.errors))}
                                            </Form.Text>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12}>
                                        <Form.Group controlId="">
                                            <Form.Label >Total Text/SMS
                                            <Tooltip title="Place 0 for unlimited Text/SMS">
                                                            <InfoSharpIcon style={{ fontSize: 18 }} />
                                                        </Tooltip>
                                            </Form.Label>

                                            <NumericInput
                                                name="totalText"
                                                placeholder="Enter Value"
                                                inputMode="numeric"
                                                strict
                                                style={false}
                                                className='form-control text-right emd-input'
                                                value={!!this.state.totalText && this.state.totalText !== '' ?this.state.totalText:0}
                                                onChange={(e) => {
                                                    this.setState({ totalText: e })
                                                    this.props.updateSubscriptionData('textSentCounter', e);
                                                }}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12}>
                                        <Form.Group controlId="">
                                            <Form.Label >Total Custom Templates
                                                <Tooltip title="Place 0 for unlimited Templates">
                                                            <InfoSharpIcon style={{ fontSize: 18 }} />
                                                        </Tooltip>
                                            </Form.Label>

                                            <NumericInput
                                                name="totalTemplate"
                                                placeholder="Enter Value"
                                                inputMode="numeric"
                                                strict
                                                style={false}
                                                className='form-control text-right emd-input'
                                                value={!!this.state.totalTemplate && this.state.totalTemplate !== ''?this.state.totalTemplate:0}
                                                onChange={(e) => {
                                                    this.setState({ totalTemplate: e })
                                                    this.props.updateSubscriptionData('templateCounter', e);
                                                }}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12}>
                                        <Form.Group controlId="">
                                            <Form.Label >Total Documents Size(MB) <Tooltip title="Place 0 for unlimited Documents">
                                                            <InfoSharpIcon style={{ fontSize: 18 }} />
                                                        </Tooltip></Form.Label>
                                            <NumericInput
                                                name="totalDocument"
                                                placeholder="Enter Value"
                                                inputMode="numeric"
                                                strict
                                                style={false}
                                                className='form-control text-right emd-input'
                                                value={!!this.state.totalDocument && this.state.totalDocument !== ''?this.state.totalDocument:0}
                                                onChange={(e) => {
                                                    this.setState({ totalDocument: e })
                                                    this.props.updateSubscriptionData('uploadDocumentSize', e);
                                                }}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12}>
                                        <Form.Group controlId="">
                                            <Form.Label >Total Emails <Tooltip title="Place 0 for unlimited Emails">
                                                            <InfoSharpIcon style={{ fontSize: 18 }} />
                                                        </Tooltip></Form.Label>

                                            <NumericInput
                                                name="totalEmail"
                                                placeholder="Enter Value"
                                                inputMode="numeric"
                                                strict
                                                style={false}
                                                className='form-control text-right emd-input'
                                                value={!!this.state.totalEmail && this.state.totalEmail !== ''?this.state.totalEmail:0}
                                                onChange={(e) => {
                                                    this.setState({ totalEmail: e })
                                                    this.props.updateSubscriptionData('emailSentCounter', e);
                                                }}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>

                    </Form>
                    <Modal
                        show={this.state.deletePrompt}
                        dialogClassName="modal-90w"
                        aria-labelledby="example-custom-modal-styling-title"
                        className="modal-med modal-400 modal-delete"
                        centered
                        backdrop={false}
                    >
                        <Modal.Body className="pb-0 text-center">
                            <HelpOutline />
                            <p>Are you sure you want to delete?</p>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant='primary' className="btn-blue btn-outlined w-140" onClick={() => { this.deletePrompt() }}>Cancel</Button>
                            <Button variant='primary' className="btn-blue w-140" onClick={() => { this.deleteImage(0) }}>Yes</Button>
                        </Modal.Footer>
                    </Modal>
                </div>

            </div>
        );
    }

}


ProductInfo.propTypes = {
    errors: PropTypes.object,
    handleValidation: PropTypes.func,

};

export default validation(strategy)(ProductInfo)


